/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './json-content.scss';

import 'brace/ext/language_tools';
import 'brace/mode/json';
import 'brace/mode/text';
import 'brace/mode/sh';
import 'ace-builds/src-min-noconflict/snippets/json';
import 'ace-builds/src-min-noconflict/snippets/text';

/* eslint-disable import/no-unresolved, import/default */

import jsonContentTemplate from './json-content.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.components.jsonContent', [])
    .directive('tkJsonContent', JsonContent)
    .name;

/*@ngInject*/
function JsonContent($compile, $templateCache, toast, types, utils) {

    var linker = function (scope, element, attrs, ngModelCtrl) {
        var template = $templateCache.get(jsonContentTemplate);
        element.html(template);

        scope.label = attrs.label;

        scope.contentValid = true;

        scope.json_editor;

        scope.onFullscreenChanged = function () {
            if (scope.json_editor) {
                scope.json_editor.resize();
                scope.json_editor.renderer.updateFull();
            }
        };

        var mode;
        if (scope.contentType) {
            var type = types.contentType[scope.contentType];
            if (type) {
                mode = type.code;
            } else {
                mode = scope.contentType;
            }
        } else {
            mode = 'text';
        }

        scope.jsonEditorOptions = {
            useWrapMode: true,
            mode: mode,
            advanced: {
                enableSnippets: true,
                enableBasicAutocompletion: true,
                enableLiveAutocompletion: true
            },
            onLoad: function (_ace) {
                scope.json_editor = _ace;
                scope.json_editor.session.on("change", function () {
                    scope.cleanupJsonErrors();
                });
            }
        };

        scope.$watch('contentType', () => {
            var mode;
            if (scope.contentType) {
                var type = types.contentType[scope.contentType];
                if (type) {
                    mode = type.code;
                } else {
                    mode = scope.contentType;
                }
            } else {
                mode = 'text';
            }
            if (scope.json_editor) {
                scope.json_editor.session.setMode('ace/mode/' + mode);
            }
        });

        scope.cleanupJsonErrors = function () {
            toast.hide();
        };

        scope.updateValidity = function () {
            ngModelCtrl.$setValidity('contentBody', scope.contentValid);
            if (scope.required) {
                ngModelCtrl.$setValidity('required', scope.contentBody && scope.contentBody.length ? true : false);
            }
        };

        scope.$watch('contentBody', function (newContent, oldContent) {
            ngModelCtrl.$setViewValue(scope.contentBody);
            if (!angular.equals(newContent, oldContent)) {
                scope.contentValid = true;
            }
            scope.updateValidity();
        });

        ngModelCtrl.$render = function () {
            scope.contentBody = ngModelCtrl.$viewValue;
        };

        scope.showError = function (error) {
            var toastParent = angular.element('#tk-json-panel', element);
            toast.showError(error, toastParent, 'top left');
        };

        scope.validate = function () {
            try {
                if (scope.validateContent) {
                    if (scope.contentType == types.contentType.JSON.value) {
                        angular.fromJson(scope.contentBody);
                    }
                }
                return true;
            } catch (e) {
                var details = utils.parseException(e);
                var errorInfo = 'Error:';
                if (details.name) {
                    errorInfo += ' ' + details.name + ':';
                }
                if (details.message) {
                    errorInfo += ' ' + details.message;
                }
                scope.showError(errorInfo);
                return false;
            }
        };

        scope.$on('form-submit', function () {
            if (!scope.readonly) {
                scope.contentValid = scope.validate();
                scope.updateValidity();
            }
        });

        $compile(element.contents())(scope);
    }

    return {
        restrict: "E",
        require: "^ngModel",
        scope: {
            contentType: '=',
            validateContent: '=?',
            readonly:'=ngReadonly',
            required:'=ngRequired'
        },
        link: linker
    };
}



// WEBPACK FOOTER //
// ./src/app/components/json-content.directive.js